import store from '@/state/store';
import { categories, classification } from '@/api/project';
import { handleError } from '@/actions/common';
import projectSlice from '@/state/project.slice';
import processTree from './process-tree';
import { ApiError } from '@bimdata/client';
import { FolderTreeNodeStats } from '@bimdata/definitions/dto';
import { Logger } from '@bimdata/client';
import t from '@/utils/translate';

export async function loadStats(id: string, accessToken?: string): Promise<FolderTreeNodeStats[]> {
  let tree: FolderTreeNodeStats[] = [];
  try {
    const cts = await categories(id, 'Классификация', accessToken);
    tree = cts.length ? await classification(id, cts[0].id, accessToken) : [];
  } catch (e) {
    Logger.error(e);
  }
  return tree;
}

export default async (accessToken?: string): Promise<void> => {
  const { projects } = store.getState();
  if (!projects.current) return;

  try {
    const tree: FolderTreeNodeStats[] = await loadStats(projects.current.code, accessToken);
    store.dispatch(projectSlice.actions.classificationLoaded(processTree(tree).classification));
    // store.dispatch(commonSlice.actions.setTitle(p.name));
  } catch (error) {
    if (error instanceof Error) {
      if (error instanceof ApiError && (error.code === 404 || error.code === 403)) {
        error.message = t('project.error.notFoundOrAccessDenied');
      }
      handleError(error, accessToken);
    } else {
      throw error;
    }
  }
};
